import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FeedbackPriveCard.module.css';
import { formatDate } from '../../utils/format';

/* ============================================================
   FeedbackPriveCard — carte d'un feedback privé intercepté (funnel V2)
   ------------------------------------------------------------
   Composant partagé entre :
     - l'onglet Collecte (section « Feedbacks privés reçus »)
     - la page dédiée /feedbacks (« pare-feu » rendu tangible)

   Auto-suffisant : lit lui-même useTranslation('tabs') + la locale active.
   Réutilise les libellés existants collecte.feedback_sat_* (pas de doublon i18n).

   Props :
     - feedback : { prenom, satisfaction, rps_score, texte, telephone_client, created_at }
   ============================================================ */

const SAT_MAP = {
  excellent: { emoji: '😊', labelKey: 'collecte.feedback_sat_excellent', color: '#0A7A45' },
  satisfait: { emoji: '😊', labelKey: 'collecte.feedback_sat_excellent', color: '#0A7A45' },
  happy:     { emoji: '😊', labelKey: 'collecte.feedback_sat_excellent', color: '#0A7A45' },
  bien:      { emoji: '😐', labelKey: 'collecte.feedback_sat_bien',      color: '#F59E0B' },
  moyen:     { emoji: '🙁', labelKey: 'collecte.feedback_sat_decu',      color: '#E8502A' },
};

export default function FeedbackPriveCard({ feedback }) {
  const { t, i18n } = useTranslation('tabs');
  const lang = i18n.language;

  const satInfo = SAT_MAP[feedback.satisfaction] || {
    emoji: '💬', labelKey: 'collecte.feedback_sat_unknown', color: '#6E6C62',
  };

  const dateStr = feedback.created_at
    ? formatDate(feedback.created_at, lang, {
        day: '2-digit', month: '2-digit', year: '2-digit',
        hour: '2-digit', minute: '2-digit',
      })
    : '—';

  return (
    <div className={styles.feedbackCard}>
      <div className={styles.feedbackHead}>
        <div className={styles.feedbackHeadLeft}>
          <strong>{feedback.prenom || t('collecte.feedback_anonymous')}</strong>
          <span
            className={styles.feedbackSatBadge}
            style={{ background: satInfo.color + '22', color: satInfo.color }}
          >
            {satInfo.emoji} {t(satInfo.labelKey)}
          </span>
          {feedback.rps_score != null && (
            <span className={styles.feedbackRpsBadge}>
              {t('collecte.feedback_rps_label', { score: feedback.rps_score })}
            </span>
          )}
        </div>
        <span className={styles.feedbackDate}>{dateStr}</span>
      </div>
      <p className={styles.feedbackText}>« {feedback.texte} »</p>
      {feedback.telephone_client && (
        <div className={styles.feedbackTel}>📱 {feedback.telephone_client}</div>
      )}
    </div>
  );
}
